import { useEffect, useMemo, useRef, useState } from "react";
import { Search } from "lucide-react";

export default function EntityPicker({ contacts = [], value, onChange, placeholder = "Search contacts…" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [active, setActive] = useState(0);
  const ref = useRef(null);
  const inputRef = useRef(null);
  const selected = contacts.find((c) => c.id === value);

  const recentIds = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("crm_recent_contacts") || "[]").slice(0, 8);
    } catch {
      return [];
    }
  }, [open]);

  const options = useMemo(() => {
    const query = q.trim().toLowerCase();
    let list = contacts.filter((c) => !c.isInternal);
    if (query) {
      list = list.filter((c) => {
        const hay = `${c.name} ${c.email} ${c.companyName}`.toLowerCase();
        return hay.includes(query);
      });
    } else {
      const recent = recentIds.map((id) => contacts.find((c) => c.id === id)).filter(Boolean);
      const rest = list.filter((c) => !recentIds.includes(c.id));
      list = [...recent, ...rest].slice(0, 40);
    }
    return list.slice(0, 50);
  }, [contacts, q, recentIds]);

  useEffect(() => {
    const fn = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  function pick(id) {
    onChange?.(id || "");
    setOpen(false);
    setQ("");
  }

  return (
    <div className="entity-picker" ref={ref}>
      <div className="entity-picker-trigger" onClick={() => { setOpen(true); inputRef.current?.focus(); }}>
        <Search size={14} />
        <input
          ref={inputRef}
          className="entity-picker-input"
          value={open ? q : selected?.name || ""}
          placeholder={placeholder}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onKeyDown={(e) => {
            if (e.key === "ArrowDown") { e.preventDefault(); setActive((i) => Math.min(i + 1, options.length)); }
            if (e.key === "ArrowUp") { e.preventDefault(); setActive((i) => Math.max(i - 1, 0)); }
            if (e.key === "Enter" && options[active]) { e.preventDefault(); pick(options[active].id); }
          }}
        />
      </div>
      {open && (
        <div className="entity-picker-dropdown">
          <button type="button" className="entity-picker-option" onClick={() => pick("")}>No contact</button>
          {options.map((c, i) => (
            <button key={c.id} type="button" className={`entity-picker-option${active === i ? " active" : ""}`} onClick={() => pick(c.id)}>
              <span className="entity-picker-name">{c.name || c.email}</span>
              <span className="entity-picker-sub">{c.companyName || c.email}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
